import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const CustomToggleButtonGroup = ({ value, onChange, options, sx = {}, buttonSx = {} }) => {
  const theme = useTheme();

  return (
    <ToggleButtonGroup
      color="primary"
      value={value}
      exclusive
      onChange={onChange}
      sx={{
        display: 'flex',
        width: '100%',
        gap: '12px',
        backgroundColor: 'transparent',
        "& .MuiToggleButton-root": {
          px: { xs: 1, sm: 2 },
          py: { xs: 0.5, sm: 1 },
          fontSize: { xs: '0.8rem', sm: '0.875rem' },
          flex: 1,
          backgroundColor: 'rgba(255,255,255,0.08)',
          color: '#fff',
          borderRadius: '8px !important',
          border: '1px solid rgba(255,255,255,0.2) !important',
          textTransform: 'none',
          fontWeight: 500,
          '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.15)',
          },
          ...buttonSx,
        },
        "& .MuiToggleButton-root.Mui-selected": {
          backgroundColor: '#00ff88',
          color: '#000814',
          fontWeight: 600,
          border: '1px solid #00ff88 !important',
          "&:hover": {
            backgroundColor: '#00cc6d',
          },
        },
        ...sx,
      }}
    >
      {options.map((option) => (
        <ToggleButton key={option.value} value={option.value}>
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default CustomToggleButtonGroup;
